<!-- eslint-disable max-len -->
<template>
  <div>
    <nav
      class="bg-blue-800 pt-2 md:pt-1 pb-1 px-1 mt-0 h-auto fixed w-full z-20 top-0"
    >
      <div class="flex flex-wrap items-center">
        <div
          class="flex flex-shrink md:w-1/3 justify-center md:justify-start text-white"
        >
          <router-link :to="{ name: 'Dashboard' }" >
            <div class="w-20 p-2 ml-10">
              <img src="@/assets/logo-dashboard.png" />
            </div>
          </router-link>
        </div>

        <div
          class="flex flex-1 md:w-1/3 justify-center md:justify-start text-white px-2"
        >
          <span class="relative w-full">
          </span>
        </div>

        <div
          class="flex w-full pt-2 content-center justify-between md:w-1/3 md:justify-end"
        >
          <ul
            class="list-reset flex justify-between flex-1 md:flex-none items-center h-10"
          >
            <li class="flex-1 md:flex-none md:mr-3">
              <div class="relative inline-block">
                <button
                  @click="toggleDD()"
                  class="drop-button text-white focus:outline-none"
                >
                  <span class="pr-2"><i class="em em-robot_face"></i></span> Hi,
                  {{ getName }}
                  <svg
                    class="h-3 fill-current inline"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                  >
                    <path
                      d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                    />
                  </svg>
                </button>
                <div
                  id="myDropdown"
                  class="dropdownlist w-40 absolute bg-gray-900 text-white right-0 mt-3 p-3 overflow-auto z-30"
                  style="display: none"
                >
                  <a @click="toggleDD('profile')" class="p-2 hover:bg-gray-800 text-white text-sm no-underline hover:no-underline block" >
                  Profile
                  </a>
                  <a v-if="!isSuperAdmin" @click="toggleDD('change-password-user')" class="p-2 hover:bg-gray-800 text-white text-sm no-underline hover:no-underline block" >
                    Change Password
                  </a>
                  <div class="border border-gray-800"></div>
                  <a
                    @click="logout"
                    class="p-2 hover:bg-gray-800 text-white text-sm no-underline hover:no-underline block"
                    ><i class="fas fa-sign-out-alt fa-fw"></i> Log Out</a
                  >
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <div class="flex flex-col md:flex-row overflow-y-hidden max-h-screen-musicverse">
      <div
        class="bg-blue-800 shadow-lg h-16 fixed bottom-0 mt-12 md:relative md:h-screen z-10 w-full md:w-56"
      >
        <div
          class="md:mt-20 md:w-56 md:fixed md:left-0 md:top-0 content-center md:content-start text-left justify-between overflow-y-auto pb-6" style="height:90vh"
        >
          <ul
            class="list-reset flex flex-row md:flex-col py-0 md:py-3 px-1 md:px-2 text-center md:text-left "
          >
            <li v-if="!isReviewer && !isRecruitment && !isFinance" class="mr-3 flex-1">
              <router-link :to="{ name: 'Statistic' }" >
              <a
                href="#"
                class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-pink-500"
                :class="currentRoute === 'Statistic' ? 'border-pink-500' : '' "
              >
                <font-awesome-icon :icon="['fas', 'chart-line']" size="2x" class="pt-3 pr-0 md:pr-3" />
                <span class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block">Home</span>
              </a>
              </router-link>
            </li>
            <li v-if="isOps || isAdmin || isSuperAdmin || isReviewer" class="mr-3 flex-1">
              <router-link :to="{ name: isReviewer ? 'HomeSection' : 'AdsSettings' }">
                <a
                  class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                >
                  <font-awesome-icon :icon="['fa', 'cogs']" size="2x" class="pt-3 pr-0 md:pr-3" />
                  <span
                    class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                  >App Settings</span>
                </a>
              </router-link>
              <ul v-if="isAppSettingMenu" >
                <li class="ml-5 flex-1"  v-if="!isReviewer">
                  <router-link :to="{ name: 'AdsSettings' }">
                    <a
                      class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                      :class="currentRoute === 'AdsSettings' ? 'border-yellow-500' : '' "
                    >
                      <span
                        class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                      >Ads</span>
                    </a>
                  </router-link>
                  <router-link :to="{ name: 'SkipQuotaSettings' }" v-if="false">
                    <a
                      class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                      :class="currentRoute === 'SkipQuotaSettings' ? 'border-yellow-500' : '' "
                    >
                      <span
                        class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                      >Skip Quota</span>
                    </a>
                  </router-link>
                  <router-link :to="{ name: 'AccountDeletionSurvey' }" v-if="!isReviewer">
                    <a
                      class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                      :class="currentRoute === 'AccountDeletionSurvey' ? 'border-yellow-500' : '' "
                    >
                      <span
                        class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                      >Account Deletion Survey</span>
                    </a>
                  </router-link>
                  <router-link :to="{ name: 'HomeSection' }">
                    <a
                      class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                      :class="currentRoute === 'HomeSection' ||  currentRoute === 'HomeSectionDetail'? 'border-yellow-500' : '' "
                    >
                      <span
                        class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                      >Home Section</span>
                    </a>
                  </router-link>
                  <router-link :to="{ name: 'OnboardingBanner' }">
                    <a
                      class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                      :class="currentRoute === 'OnboardingBanner'? 'border-yellow-500' : '' "
                    >
                      <span
                        class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                      >Onboarding Banner</span>
                    </a>
                  </router-link>
                  <router-link :to="{ name: 'ReferralBanner' }">
                    <a
                      class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                      :class="currentRoute === 'ReferralBanner'? 'border-yellow-500' : '' "
                    >
                      <span
                        class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                      >Referral Banner</span>
                    </a>
                  </router-link>
                  <router-link :to="{ name: 'ReferralAbout' }">
                    <a
                      class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                      :class="currentRoute === 'ReferralAbout'? 'border-yellow-500' : '' "
                    >
                      <span
                        class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                      >Referral About</span>
                    </a>
                  </router-link>
                </li>
              </ul>
            </li>
            <li v-if="isOps || isAdmin || isSuperAdmin" class="mr-3 flex-1">
              <router-link :to="{ name: 'MusicCategoriesPage' }">
                <a
                  class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                >
                  <font-awesome-icon :icon="['fa', 'list-ul']" size="2x" class="pt-3 pr-0 md:pr-3" />
                  <span
                    class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                  >Categories</span>
                </a>
              </router-link>
              <ul v-if="isCategoriesMenu" >
                <li class="ml-5 flex-1"  >
                  <router-link :to="{ name: 'MusicCategoriesPage' }">
                    <a
                      class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                      :class="currentRoute === 'MusicCategoriesPage' ? 'border-yellow-500' : '' "
                    >
                      <span
                        class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                      >Music Categories</span>
                    </a>
                  </router-link>
                  <router-link :to="{ name: 'MissionCategoriesPage' }">
                    <a
                      class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                      :class="currentRoute === 'MissionCategoriesPage' ? 'border-yellow-500' : '' "
                    >
                      <span
                        class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                      >Missions Videos Categories</span>
                    </a>
                  </router-link>
                </li>
              </ul>
            </li>
            <li v-if="isOps || isAdmin || isSuperAdmin" class="mr-3 flex-1">
              <router-link to="/missions-videos">
                <a
                  class="block py-1 md:py-3 pl-0 md:pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-blue-500"
                >
                  <font-awesome-icon :icon="['fas', 'video']" size="2x" class="pt-3 pr-0 md:pr-3" />
                  <span
                    class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block overflow-ellipsis"
                  >Missions Videos</span>
                </a>
              </router-link>
              <ul v-if="isMissionsVideosMenu" >
                <li class="ml-5 flex-1" >
                  <router-link :to="{ name: 'ChannelListPage' }">
                    <a
                      class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                      :class="currentRoute === 'ChannelListPage' ? 'border-blue-500' : '' "
                    >
                      <span
                        class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                      >Channel List</span>
                    </a>
                  </router-link>
                </li>
                <li class="ml-5 flex-1" >
                  <router-link :to="{ name: 'RecommendedVideosPage' }">
                    <a
                      class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                      :class="currentRoute === 'RecommendedVideosPage' ? 'border-blue-500' : '' "
                    >
                      <span
                        class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                      >Recommended Video</span>
                    </a>
                  </router-link>
                </li>
              </ul>
            </li>
            <li v-if="isAdmin || isSuperAdmin || isReviewer" class="mr-3 flex-1">
              <router-link :to="{ name: 'ListPlaylist' }" >
                <a
                  href="#"
                  class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-pink-500"
                  :class="isPlaylistMenu ? 'border-pink-500' : '' "
                >
                  <font-awesome-icon :icon="['fas', 'play-circle']" size="2x" class="pt-3 pr-0 md:pr-3" />
                  <span class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block">Playlist</span>
                </a>
              </router-link>
            </li>
            <li v-if="isOps || isAdmin || isSuperAdmin" class="mr-3 flex-1">
              <router-link :to="{ name: 'Users' }">
                <a
                  class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                >
                  <font-awesome-icon :icon="['fa', 'users']" size="2x" class="pt-3 pr-0 md:pr-3" />
                  <span
                    class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                  >Users</span>
                </a>
              </router-link>
              <ul v-if="isUserMenu" >
                <li class="ml-5 flex-1" >
                  <router-link :to="{ name: 'Users' }">
                    <a
                      class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                      :class="currentRoute === 'Users' ? 'border-yellow-500' : '' "
                    >
                      <span
                        class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                      >App Users</span>
                    </a>
                  </router-link>
                </li>
                <li v-if="isSuperAdmin" class="ml-5 flex-1" >
                  <router-link :to="{ name: 'UsersAdmin' }">
                    <a
                      class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                      :class="currentRoute === 'UsersAdmin' ? 'border-yellow-500' : '' "
                    >
                      <span
                        class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                      >Admin Users</span>
                    </a>
                  </router-link>
                </li>
                <li class="ml-5 flex-1" >
                  <router-link :to="{ name: 'UsersDeletedPage' }">
                    <a
                      class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                      :class="currentRoute === 'UsersDeletedPage' ? 'border-yellow-500' : '' "
                    >
                      <span
                        class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                      >Deleted App Users</span>
                    </a>
                  </router-link>
                </li>
              </ul>
            </li>
            <li v-if="isOps || isAdmin || isSuperAdmin || isRecruitment" class="mr-3 flex-1">
              <router-link to="/artists">
                <a
                  class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-green-500"
                >
                  <font-awesome-icon :icon="['fa', 'drum']" size="2x" class="pt-3 pr-0 md:pr-3" />
                  <span
                    class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                  >Artists</span
                  >
                </a>
              </router-link>
              <ul v-if="isArtistManagementMenu" >
                <li class="ml-5 flex-1" >
                  <router-link :to="{ name: 'Artists' }">
                    <a
                      class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                      :class="currentRoute === 'Artists' || currentRoute === 'DetailArtistPage' || currentRoute === 'AddArtistPage'? 'border-red-500' : '' "
                    >
                      <span
                        class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                      >Artist List</span>
                    </a>
                  </router-link>
                </li>
                <li class="ml-5 flex-1" >
                  <router-link :to="{ name: 'DraftArtistPage' }">
                    <a
                      class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                      :class="currentRoute === 'DraftArtistPage' ? 'border-red-500' : '' "
                    >
                      <span
                        class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                      >Draft</span>
                    </a>
                  </router-link>
                </li>
              </ul>
            </li>
            <li v-if="!isFinance" class="mr-3 flex-1">
              <router-link :to="{ name: !isArtist?'SongManagement':'Album' }">
              <a
                class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
              >
                <font-awesome-icon :icon="['fa', 'music']" size="2x" class="pt-3 pr-0 md:pr-3" />
                <span
                  class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                  >Content</span
                >
              </a>
              </router-link>
              <ul v-if="isAlbumMenu" >
                <li class="ml-5 flex-1" v-if="!isArtist">
                  <router-link :to="{ name: 'SongManagement' }">
                  <a
                    class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                    :class="currentRoute === 'SongManagement' ? 'border-purple-500' : '' "
                  >
                    <font-awesome-icon :icon="['fa', 'angle-right']" size="2x" class="pt-3 pr-0 md:pr-3" />
                    <span
                      class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                      >Songs</span
                    >
                  </a>
                  </router-link>
                </li>
                <li class="ml-5 flex-1" >
                  <router-link to="/album">
                  <a
                    class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                    :class="currentRoute === 'Album' ? 'border-purple-500' : '' "
                  >
                    <font-awesome-icon :icon="['fa', 'angle-right']" size="2x" class="pt-3 pr-0 md:pr-3" />
                    <span
                      class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                      >Albums</span
                    >
                  </a>
                  </router-link>
                </li>
                <li v-if="!isArtist" class="ml-5 flex-1" >
                  <router-link to="/artist-bio">
                    <a
                      class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                      :class="currentRoute === 'ArtistBio' ? 'border-purple-500' : '' "
                    >
                      <font-awesome-icon :icon="['fa', 'angle-right']" size="2x" class="pt-3 pr-0 md:pr-3" />
                      <span
                        class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                      >Bio</span
                      >
                    </a>
                  </router-link>
                </li>
              </ul>
            </li>
            <li v-if="isArtist" class="mr-3 flex-1">
              <router-link to="/purchase-history">
                <a
                  class="block py-1 md:py-3 pl-0 md:pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-red-500"
                >
                  <font-awesome-icon :icon="['fas', 'chart-bar']" size="2x" class="pt-3 pr-0 md:pr-3" />
                  <span
                    class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                  >Transactions</span>
                </a>
              </router-link>
              <ul v-if="isTransactionsMenu" >
                <li class="ml-5 flex-1" >
                  <router-link :to="{ name: 'StreamListPage' }">
                    <a
                      class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                      :class="currentRoute === 'StreamListPage' ? 'border-purple-500' : '' "
                    >
                      <span
                        class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                      >Stream</span
                      >
                    </a>
                  </router-link>
                </li>
                <li class="ml-5 flex-1" >
                  <router-link :to="{ name: 'Transactions' }">
                    <a
                      class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                      :class="currentRoute === 'Transactions' ? 'border-red-500' : '' "
                    >
                      <span
                        class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                      >Purchase</span
                      >
                    </a>
                  </router-link>
                </li>
                <li class="ml-5 flex-1" >
                  <router-link :to="{ name: 'EarningPage' }">
                    <a
                      class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                      :class="currentRoute === 'EarningPage' ? 'border-purple-500' : '' "
                    >
                      <span
                        class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                      >Earnings</span
                      >
                    </a>
                  </router-link>
                </li>
              </ul>
            </li>
            <li v-if="isOps || isAdmin || isSuperAdmin" class="mr-3 flex-1">
              <router-link to="/tnc-management">
              <a
                class="block py-1 md:py-3 pl-0 md:pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-blue-500"
                :class="currentRoute === 'TncManagement' ? 'border-blue-500' : '' "
              >
                <font-awesome-icon :icon="['fas', 'file-contract']" size="2x" class="pt-3 pr-0 md:pr-3" />
                <span
                  class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block overflow-ellipsis"
                  >Term of Service</span
                >
              </a>
              </router-link>
            </li>
            <li v-if="isOps || isAdmin || isSuperAdmin" class="mr-3 flex-1">
              <router-link to="/credits-amount">
                <a
                  class="block py-1 md:py-3 pl-0 md:pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-red-500"
                >
                  <font-awesome-icon :icon="['fas', 'money-bill']" size="2x" class="pt-3 pr-0 md:pr-3" />
                  <span
                    class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                  >Pricing</span>
                </a>
              </router-link>
              <ul v-if="isPricingMenu" >
                <li class="ml-5 flex-1" >
                  <router-link :to="{ name: 'CreditsAmount' }">
                    <a
                      class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                      :class="currentRoute === 'CreditsAmount' ? 'border-red-500' : '' "
                    >
                      <span
                        class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                      >Credits Amount</span
                      >
                    </a>
                  </router-link>
                </li>
                <li class="ml-5 flex-1" >
                  <router-link :to="{ name: 'SubscriptionSettingPage' }">
                    <a
                      class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                      :class="currentRoute === 'SubscriptionSettingPage' ? 'border-red-500' : '' "
                    >
                      <span
                        class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                      >Subscription</span
                      >
                    </a>
                  </router-link>
                </li>
                <li class="ml-5 flex-1" >
                  <router-link :to="{ name: 'IapManagement' }">
                    <a
                      class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                      :class="currentRoute === 'IapManagement' ? 'border-red-500' : '' "
                    >
                      <span
                        class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                      >In-App Purchase</span
                      >
                    </a>
                  </router-link>
                </li>
              </ul>
            </li>
            <li v-if="isOps || isAdmin || isSuperAdmin" class="mr-3 flex-1">
              <router-link to="/transaction-history">
                <a
                  class="block py-1 md:py-3 pl-0 md:pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-red-500"
                >
                  <font-awesome-icon :icon="['fas', 'clipboard-list']" size="2x" class="pt-3 pr-0 md:pr-3" />
                  <span
                    class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                  >Transactions</span>
                </a>
              </router-link>
              <ul v-if="isTransactionsAdminMenu" >
                <li class="ml-5 flex-1" >
                  <router-link :to="{ name: 'TransactionHistoryPage' }">
                    <a
                      class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                      :class="currentRoute === 'TransactionHistoryPage' ? 'border-purple-500' : '' "
                    >
                      <span
                        class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                      >Content Purchase</span
                      >
                    </a>
                  </router-link>
                </li>
                <li class="ml-5 flex-1" >
                  <router-link :to="{ name: 'CreditPurchasePage' }">
                    <a
                      class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                      :class="currentRoute === 'CreditPurchasePage' ? 'border-purple-500' : '' "
                    >
                      <span
                        class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                      >Credit Purchase</span
                      >
                    </a>
                  </router-link>
                </li>
                <li class="ml-5 flex-1" >
                  <router-link :to="{ name: 'SubscriptionHistoryPage' }">
                    <a
                      class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                      :class="currentRoute === 'SubscriptionHistoryPage' ? 'border-purple-500' : '' "
                    >
                      <span
                        class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                      >Subscription</span
                      >
                    </a>
                  </router-link>
                </li>
                <li class="ml-5 flex-1" >
                  <router-link :to="{ name: 'RedemptionHistoryPage' }">
                    <a
                      class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                      :class="currentRoute === 'RedemptionHistoryPage' ? 'border-purple-500' : '' "
                    >
                      <span
                        class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                      >Redemption</span
                      >
                    </a>
                  </router-link>
                </li>
              </ul>
            </li>
            <li v-if="!isArtist && !isRecruitment && !isReviewer"class="mr-3 flex-1">
              <router-link :to="{ name: 'PayoutList' }">
                <a
                  class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                >
                  <font-awesome-icon :icon="['fa', 'chart-bar']" size="2x" class="pt-3 pr-0 md:pr-3" />
                  <span
                    class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                  >Finance</span
                  >
                </a>
              </router-link>
              <ul v-if="isFinanceMenu" >
                <li class="ml-5 flex-1" >
                  <router-link :to="{ name: 'PayoutList' }">
                    <a
                      class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                      :class="currentRoute === 'PayoutList' ? 'border-purple-500' : '' "
                    >
                      <span
                        class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                      >Payout List</span
                      >
                    </a>
                  </router-link>
                </li>
                <li class="ml-5 flex-1" >
                  <router-link :to="{ name: 'TransferHistory' }">
                    <a
                      class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                      :class="currentRoute === 'TransferHistory' ? 'border-purple-500' : '' "
                    >
                      <span
                        class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                      >Transfer History</span
                      >
                    </a>
                  </router-link>
                </li>
              </ul>
            </li>
            <li v-if="isOps || isAdmin || isSuperAdmin" class="mr-3 flex-1">
              <router-link :to="{ name: 'RatingList' }">
                <a
                  class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                >
                  <font-awesome-icon :icon="['fa', 'star']" size="2x" class="pt-3 pr-0 md:pr-3" />
                  <span
                    class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                  >Rating and Survey</span
                  >
                </a>
              </router-link>
              <ul v-if="isRatingSurveyMenu" >
                <li class="ml-5 flex-1" >
                  <router-link :to="{ name: 'RatingList' }">
                    <a
                      class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                      :class="currentRoute === 'RatingList' ? 'border-purple-500' : '' "
                    >
                      <span
                        class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                      >Ratings</span
                      >
                    </a>
                  </router-link>
                </li>
                <li class="ml-5 flex-1" >
                  <router-link :to="{ name: 'SurveyList' }">
                    <a
                      class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                      :class="currentRoute === 'SurveyList' ? 'border-purple-500' : '' "
                    >
                      <span
                        class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                      >Survey</span
                      >
                    </a>
                  </router-link>
                </li>
              </ul>
            </li>
            <li v-if="isOps || isAdmin || isSuperAdmin" class="mr-3 flex-1">
              <router-link :to="{ name: 'ReferralDataBannerPage' }">
                <a
                  class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                >
                  <font-awesome-icon :icon="['fa', 'users']" size="2x" class="pt-3 pr-0 md:pr-3" />
                  <span
                    class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                  >Referral Data</span>
                </a>
              </router-link>
              <ul v-if="isReferralDataMenu" >
                <li class="ml-5 flex-1" >
                  <router-link :to="{ name: 'ReferralDataBannerPage' }">
                    <a
                      class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                      :class="currentRoute === 'ReferralDataBannerPage' ? 'border-yellow-500' : '' "
                    >
                      <span
                        class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                      >Banner Click</span>
                    </a>
                  </router-link>
                </li>
                <li class="ml-5 flex-1" >
                  <router-link :to="{ name: 'ReferralDataSharePage' }">
                    <a
                      class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                      :class="currentRoute === 'ReferralDataSharePage' ? 'border-yellow-500' : '' "
                    >
                      <span
                        class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                      >Share Click</span>
                    </a>
                  </router-link>
                </li>
                <li class="ml-5 flex-1" >
                  <router-link :to="{ name: 'ReferralDataMemberPage' }">
                    <a
                      class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                      :class="currentRoute === 'ReferralDataMemberPage' ? 'border-yellow-500' : '' "
                    >
                      <span
                        class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                      >Referred Member</span>
                    </a>
                  </router-link>
                </li>
              </ul>
            </li>
            <li v-if="isOps || isAdmin || isSuperAdmin" class="mr-3 flex-1">
              <router-link :to="{ name: 'FirstTimeSubsPage' }">
                <a
                  class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                >
                  <font-awesome-icon :icon="['fa', 'users']" size="2x" class="pt-3 pr-0 md:pr-3" />
                  <span
                    class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                  >Subscription</span>
                </a>
              </router-link>
              <ul v-if="isSubscriptionMenu" >
                <li class="ml-5 flex-1" >
                  <router-link :to="{ name: 'FirstTimeSubsPage' }">
                    <a
                      class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                      :class="currentRoute === 'FirstTimeSubsPage' ? 'border-yellow-500' : '' "
                    >
                      <span
                        class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                      >First Time</span>
                    </a>
                  </router-link>
                </li>
                <li class="ml-5 flex-1" >
                  <router-link :to="{ name: 'CancelExpireSubsPage' }">
                    <a
                      class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                      :class="currentRoute === 'CancelExpireSubsPage' ? 'border-yellow-500' : '' "
                    >
                      <span
                        class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                      >Cancel & Expire</span>
                    </a>
                  </router-link>
                </li>
              </ul>
            </li>
            <li v-if="isAdmin || isSuperAdmin" class="mr-3 flex-1">
              <router-link :to="{ name: 'CLTVPage' }">
                <a
                  class="block py-1 md:py-3 pl-1 align-middle text-white no-underline hover:text-white border-b-2 border-gray-800 hover:border-purple-500"
                >
                  <font-awesome-icon :icon="['fa', 'users']" size="2x" class="pt-3 pr-0 md:pr-3" />
                  <span
                    class="pb-1 md:pb-0 text-xs md:text-base text-gray-600 md:text-gray-400 block md:inline-block"
                  >CLTV</span>
                </a>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <ModalTermAndConditions
        :isShowingModal="isShowingModalTermsandCondition"
        :isHideToggle="true"
        :isLoading="isLoading"
        @save="processAcceptToc()"
      />
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ModalTermAndConditions from '../components/Common/ModalTermAndConditions';
import clevertap from 'clevertap-web-sdk';
import * as moment from 'moment';

export default {
  name: 'Dashboard',
  data: () => ({
    isShowDropdown: false,
    isShowingModalTermsandCondition: false,
  }),
  computed: {
    ...mapGetters('NotificationModule', ['isLoading', 'getStatus', 'getMessage', 'getErrorCode']),
    ...mapGetters('AuthModule', ['accessToken', 'isArtist', 'isSuperAdmin', 'isOps',
      'isRecruitment', 'isReviewer', 'isFinance', 'tokenType', 'isAdmin',
      'getName', 'isUpdateTnc', 'getUser']),
    currentRoute() {
      return this.$route.name;
    },
    isAlbumMenu() {
      return this.currentRoute === 'Album' || this.currentRoute === 'SongManagement' || this.currentRoute === 'ArtistsBio';
    },
    isArtistManagementMenu() {
      return this.currentRoute === 'Artists' || this.currentRoute === 'AddArtistPage' || this.currentRoute === 'DetailArtistPage' || this.currentRoute === 'DraftArtistPage';
    },
    isFinanceMenu() {
      return this.currentRoute === 'PayoutList' || this.currentRoute === 'TransferHistory';
    },
    isUserMenu() {
      return this.currentRoute === 'Users' || this.currentRoute === 'UsersAdmin' || this.currentRoute === 'UsersDeletedPage'
        || this.currentRoute === 'SubscriptionVerifyStudentPage' || this.currentRoute === 'SubscriptionVerifyStudentHistoryPage';
    },
    isTransactionsMenu() {
      return this.currentRoute === 'Transactions' || this.currentRoute === 'Report'
        || this.currentRoute === 'StreamListPage' || this.currentRoute === 'PurchaseListPage' || this.currentRoute === 'EarningPage';
    },
    isTransactionsAdminMenu() {
      return this.currentRoute === 'TransactionHistoryPage'
        || this.currentRoute === 'CreditPurchasePage'
        || this.currentRoute === 'SubscriptionHistoryPage'
        || this.currentRoute === 'RedemptionHistoryPage'
      ;
    },
    isPricingMenu() {
      return this.currentRoute === 'SubscriptionSettingPage' || this.currentRoute === 'CreditsAmount' || this.currentRoute === 'IapManagement';
    },
    isAppSettingMenu() {
      const listPage = ['DailyPremiumAccessPage', 'AdsSettings', 'SkipQuotaSettings', 'AccountDeletionSurvey','HomeSection','HomeSectionDetail','OnboardingBanner','ReferralBanner', 'ReferralAbout'];
      return listPage.includes(this.currentRoute);
    },
    isPlaylistMenu() {
      const listPage = ['ListPlaylist', 'AddPlaylist', 'EditPlaylist'];
      return listPage.includes(this.currentRoute);
    },
    isRatingSurveyMenu() {
      const listPage = ['RatingList', 'SurveyList'];
      return listPage.includes(this.currentRoute);
    },
    isMissionsVideosMenu() {
      const listPage = ['ChannelListPage','ChannelDetailPage','RecommendedVideosPage'];
      return listPage.includes(this.currentRoute);
    },
    isCategoriesMenu() {
      const listPage = ['MusicCategoriesPage','MissionCategoriesPage'];
      return listPage.includes(this.currentRoute);
    },
    isReferralDataMenu() {
      const listPage = ['ReferralDataBannerPage','ReferralDataSharePage','ReferralDataMemberPage'];
      return listPage.includes(this.currentRoute);
    },
    isSubscriptionMenu() {
      const listPage = ['FirstTimeSubsPage','CancelExpireSubsPage'];
      return listPage.includes(this.currentRoute);
    },
    isCLTVMenu() {
      const listPage = ['CLTVPage'];
      return listPage.includes(this.currentRoute);
    },
  },
  mounted() {
    this.toggleDashboardProfile(false);
    if (this.isArtist) {
      this.isShowingModalTermsandCondition = this.isUpdateTnc;
    }
  },
  methods: {
    ...mapActions('AuthModule', ['removeAuthentication']),
    ...mapActions('UserModule', ['acceptToc']),
    toggleDD(redirect = null) {
      if (redirect) {
        this.toggleDashboardProfile(false);
        this.$router.push({ path: `/${redirect}` });
      } else {
        this.toggleDashboardProfile();
      }
    },
    async logout() {
      this.toggleDashboardProfile();
      // eslint-disable-next-line max-len
      const result = await this.removeAuthentication({ accessToken: this.accessToken, tokenType: this.tokenType });
      if (result) {
        this.$router.go();
        window.location.reload();
      }
    },
    toggleModalTermsandCondition() {
      this.isShowingModalTermsandCondition = false;
    },
    async processAcceptToc() {
      try {
        await this.acceptToc();
        this.isShowingModalTermsandCondition = this.isUpdateTnc;
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      }
    },
  },
  components: {
    ModalTermAndConditions,
  },
};
</script>
<style>
.el-table th>.cell{
  font-size:16px;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard.vue